import Typo from '@mui/material/Typography'

import formatEuro from 'src/functions/formatEuro'
import { discountPrice } from 'src/shared/frontendTypes/product'

interface Props {
  price: number | discountPrice
  qty?: number
  className?: string
}

const StockDiscountInfo: React.FC<Props> = ({
  price,
  qty = 1,
  className,
}) => {
  if (typeof price === 'number') return null
  if (price.limitStockDiscountToStock !== true) return null
  if (typeof price.stockDiscountLimit !== 'number' || price.stockDiscountLimit <= 0) return null
  if (typeof price.discountPriceAfterStock !== 'number') return null

  const stockQty = Math.max(0, Math.floor(price.stockDiscountLimit))
  const selectedQty = Math.max(1, Math.floor(qty))
  const afterStockQty = Math.max(0, selectedQty - stockQty)
  const afterStockLabel = price.discountPriceAfterStock < price.regularPrice
    ? `${formatEuro(price.discountPriceAfterStock)} *¹ je Stück`
    : `regulärer Preis ${formatEuro(price.regularPrice)} *¹`

  const text = afterStockQty > 0
    ? `${stockQty} Stück mit Lager-Rabatt; ${afterStockQty} weitere zu ${afterStockLabel}.`
    : `Lager-Rabatt bis ${stockQty} Stück am Lager; weitere Stück zu ${afterStockLabel}.`

  return (
    <Typo
      component='span'
      variant='caption'
      color='text.secondary'
      className={className}
      sx={{ display: 'block', lineHeight: 1.45 }}
    >
      {text}
    </Typo>
  )
}

export default StockDiscountInfo
